import React from "react"
import { useQuery } from "@apollo/client"
import GET_CART_RULE from "../../../../graphql/queries/discount/GetCartRule"
import { CartRuleOutcome } from "lib/types/generated/graphql-types"
import { Discount, Id, OrderLineDiscount, RuleContainer, RuleTotal } from "./Shared.styled"
import { Link } from "react-router-dom"
import Money from "../../../Money"
import DineroFactory from "dinero.js"

type Props = {
  cartRule: CartRuleOutcome
  currencyUnit: string
  salePriceAmount: number
}

const CartRule = ({ cartRule, currencyUnit, salePriceAmount }: Props) => {
  const { data } = useQuery(GET_CART_RULE, { variables: { id: cartRule.ruleId } })
  const rule = data?.getDiscountRule

  const getPercentage = (discountAmount: number, salePriceAmount: number) => {
    return ((discountAmount / salePriceAmount) * 100).toFixed(0)
  }

  return (
    <RuleContainer>
      <div>
        <b>Cart rule: {rule?.name}</b>
        <Id>
          Rule id: <Link to={`/discounts/cart-rules/${rule?.id}`}>{rule?.id}</Link>
        </Id>
      </div>
      <RuleTotal>
        <Discount>
          <OrderLineDiscount>
            <div>Discount:</div>
            <div>
              {"- "}
              <Money
                amount={cartRule?.discountAmount ?? 0}
                currencyUnit={currencyUnit as DineroFactory.Currency}
              />
            </div>
          </OrderLineDiscount>
          <OrderLineDiscount>
            <div>Discount percentage:</div>
            {getPercentage(cartRule?.discountAmount ?? 0, salePriceAmount)}
            {"%"}
          </OrderLineDiscount>
        </Discount>
      </RuleTotal>
    </RuleContainer>
  )
}

export default CartRule
